import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Category, CategoryCollection } from '../interfaces';
import { ApiService } from './api.service';

export type CategoryFilters = {
  nom?: string
  order_by?: string;
  order?: string;
  page?: number;
  size?: number;
  fields?: {
    categories?: string;
  }
  [x: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class CategoryService extends ApiService {

  public get(id: string | number, filters: CategoryFilters = {}): Observable<Category> {
      const queryString = this.convertObjectToQueryString(filters) 
      return this.http.get<Category>(`${this.apiUrl}/categories/${id}${queryString}`)
    }
  
    public getCollection(filters: CategoryFilters = {}): Observable<CategoryCollection> {
      const queryString = this.convertObjectToQueryString(filters) 
      return this.http.get<CategoryCollection>(`${this.apiUrl}/categories/${queryString}`)
    }
  
    public post(data: Partial<Category>, filters: CategoryFilters = {}): Observable<Category> {
      const queryString = this.convertObjectToQueryString(filters) 
      return this.http.post<Category>(`${this.apiUrl}/categories/${queryString}`, data)
    }
  
    public patch(id: string | number, data: Partial<Category>, filters: CategoryFilters = {}): Observable<Category> {
      const queryString = this.convertObjectToQueryString(filters) 
      return this.http.patch<Category>(`${this.apiUrl}/categories/${id}${queryString}`, data)
    }
  
    public delete(id: string | number): Observable<string> {
      return this.http.delete<string>(`${this.apiUrl}/categories/${id}`)
    }
}
